import { z } from 'zod';

/**
 * Member moderation wire shapes shared by the client and the server.
 */

/** The longest timeout a moderator can set — 28 days, as on Discord. Longer
 *  silencing is what a ban (with an expiry) is for. */
export const MAX_TIMEOUT_MS = 28 * 24 * 60 * 60 * 1000;

const reasonSchema = z.string().trim().max(500).nullable().optional();

/**
 * `timeoutUntil` null clears the timeout. A date must lie in the future and
 * within {@link MAX_TIMEOUT_MS}: a past one stored a "timeout" that never
 * applied, and an unbounded one silenced a member for years.
 */
export const timeoutMemberSchema = z.object({
  timeoutUntil: z
    .string()
    .datetime()
    .nullable()
    .refine((value) => value === null || Date.parse(value) > Date.now(), 'timeout_in_past')
    .refine((value) => value === null || Date.parse(value) <= Date.now() + MAX_TIMEOUT_MS, 'timeout_too_long'),
  reason: reasonSchema,
});
export type TimeoutMemberInput = z.infer<typeof timeoutMemberSchema>;
